import __vue_component__ from '../Popper/Popper.vue.js';

//
var script = {
  components: {
    Popper: __vue_component__
  },
  props: {
    label: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    offset: {
      type: String,
      default: '0,5'
    },
    boundariesElement: {
      type: String,
      default: 'viewport'
    },
    targetElement: {
      type: HTMLElement,
      required: true
    },
    withDelay: {
      type: Boolean,
      default: true
    }
  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Tooltip/TooltipContent.vue_rollup-plugin-vue=script.js